import React, { useMemo } from 'react';
import styles from './labels-selector.module.scss';
import { Label } from '../../core/label';
import _ from 'lodash';
import { SelectBox, toErrorText } from 'src/components/design-system/forms';
import classNames from 'classnames';
import { normalizedContains } from 'shared/utils';

const LabelsSelectorComponent = ({
  onChange = () => {},
  error = '',
  list = [],
  labelsByIds = {},
  renderLabel = () => {},
  wrapperClass = '',
  ...props
}) => {
  const errorText = toErrorText(error);

  const onChangeInternal = React.useCallback(
    (name, value) => {
      const localValue = value.filter(v => !_.isEmpty(v));
      onChange(name, localValue);
    },
    [onChange],
  );

  // Convert list to {value, label} format with color metadata
  const options = useMemo(
    () =>
      list.map(({ code, name, color }) => ({
        value: code,
        label: name,
        color,
      })),
    [list],
  );

  // Ant Design 5 optionRender receives (option, info) where option.data has {value, label, color}
  const optionRender = option => (
    <div className={styles.optionTag}>
      {option.label}
      <Label
        color={option.data.color}
        value={option.value}
        className={styles.tagInList}
        closable={false}
      />
    </div>
  );

  const tagRender = ({ value, onClose }) => {
    const label = labelsByIds[value];

    if (!label) return null;

    return (
      <Label color={label.color} value={value} className={styles.tag} closable onClose={onClose} />
    );
  };

  if (_.isEmpty(list)) return null;

  return (
    <div className={classNames([styles.root, wrapperClass])}>
      {renderLabel && renderLabel()}
      <SelectBox
        onChange={onChangeInternal}
        filterOption={(inputValue, option) => normalizedContains(option?.label, inputValue)}
        optionRender={optionRender}
        tagRender={tagRender}
        mode="multiple"
        options={options}
        {...props}
      />
      {errorText && <span className={styles.error}>{errorText}</span>}
    </div>
  );
};

export { LabelsSelectorComponent };
